import { render } from "./ylyPlaylet‌BatchManage.vue?vue&type=template&id=63faf090&scoped=true"
import script from "./ylyPlaylet‌BatchManage.vue?vue&type=script&lang=js"
export * from "./ylyPlaylet‌BatchManage.vue?vue&type=script&lang=js"

import "./ylyPlaylet‌BatchManage.vue?vue&type=style&index=0&id=63faf090&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63faf090"]])

export default __exports__